'use client';

import type { Collection } from '@/app/actions/collection';
import type { User } from '@/types/user/type';
import type { AnswerType } from '~/model/AnswerType';
import type { ContributionType } from '~/model/ContributionType';
import type { UserInteractionStatusType } from '~/model/InteractionType';
import { useParams } from 'next/navigation';
import { useState } from 'react';
import { refreshContribution } from '@/app/actions/server/contributions';

export function useContributor({
  answers: baseAnswers,
  contributions: baseContributions,
  contributor,
  status: baseStatus,
}: {
  answers: Collection<AnswerType>;
  contributions: Collection<ContributionType>;
  contributor: User;
  status: UserInteractionStatusType;
}) {
  const { id } = useParams<{ id: string }>();

  const [answers, setAnswers] = useState<AnswerType[]>(baseAnswers?.['hydra:member'] ?? []);
  const [contributions, setContributions] = useState<ContributionType[]>(baseContributions?.['hydra:member'] ?? []);
  const [status, setStatus] = useState(baseStatus);

  const getContributions = async () => {
    const [newContributions, newStatus] = await refreshContribution(
      +id,
      {
        child: contributor.child,
        id: contributor.id,
      },
    );

    setContributions(newContributions['hydra:member']);

    if (newStatus) {
      setStatus(newStatus);
    }
  };

  return {
    answers,
    contributions,
    contributor,
    status,
    getContributions,
    setAnswers,
  };
}
